import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').constant('REGISTRATION_MODE', {
        REGISTERED_SHIPPER: 'REGISTERED_SHIPPER',
        NEW_SHIPPER: 'NEW_SHIPPER',
        TSO: 'TSO',
        SHIPPER_IN_REVIEW: 'SHIPPER_IN_REVIEW'
    });
})();
